import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/context/LanguageContext";
import { useLenis } from "@/hooks/useLenis";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";

function App() {
  useLenis();
  return (
    <div className="App">
      <div className="grain-overlay" aria-hidden="true" />
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
